import { render, staticRenderFns } from "./MenuMapTotal.vue?vue&type=template&id=0b4d4395"
import script from "./MenuMapTotal.vue?vue&type=script&lang=js"
export * from "./MenuMapTotal.vue?vue&type=script&lang=js"
import style0 from "./MenuMapTotal.vue?vue&type=style&index=0&id=0b4d4395&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports